import { OrderingDirection } from '@services/common';

import { IAutomationBlueprint, AutomationTemplateType, AutomationProvidersEnum } from './Automation';

export interface IAutomationTemplate {
  id: string;
  blueprint: IAutomationBlueprint;
  isActive: boolean;
  isSuggested: boolean;
  isUsed?: boolean;
  type?: AutomationTemplateType;
  createdDate: Date;
  updatedDate: Date;
}
export interface IAutomationTemplateFilters {
  id?: string;
  isActive?: boolean;
  isSuggested?: boolean;
  type?: AutomationTemplateType;
}

export interface IAutomationTemplateOrdering {
  weight?: OrderingDirection;
  createdDate?: OrderingDirection;
  updatedDate?: OrderingDirection;
}

export const AUTOMATION_TEMPLATE_ORDERING_FIELDS: (keyof IAutomationTemplateOrdering)[] = [
  'weight',
  'createdDate',
  'updatedDate',
];

export interface IAutomationTemplateContext {
  clientId?: string;
  programId?: number;
  providerId?: number;
  providerName?: AutomationProvidersEnum;
  isAutomationV2?: boolean;
}
